import { ChangeDetectionStrategy, Component, OnDestroy } from '@angular/core';
import { AuthService } from '@app/@core-auth';
import { UpdateUserGQL } from '@app/@graphql';
import { ChangePassword } from '@app/auth/models';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';
import { NbToastrService, NbWindowRef } from '@nebular/theme';
import { TranslateService } from '@ngx-translate/core';
import { OnDestroyMixin, untilComponentDestroyed } from '@w11k/ngx-componentdestroyed';
import { BehaviorSubject, Observable } from 'rxjs';
import { finalize, switchMap, tap } from 'rxjs/operators';

@Component({
    selector: 'ngx-change-password',
    templateUrl: './change-password.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ChangePasswordComponent extends OnDestroyMixin implements OnDestroy {
  private _loading$ = new BehaviorSubject<boolean>(false);
  private set loading(loading: boolean) {
    this._loading$.next(loading);
  }
  readonly loading$: Observable<boolean>;

  constructor(
    private translate: TranslateService,
    private windowRef: NbWindowRef,
    private toastr: NbToastrService,
    private auth: AuthService,
    private updateUserGQL: UpdateUserGQL
  ) {
    super();
    this.loading$ = this._loading$.asObservable();
  }

  ngOnDestroy() { super.ngOnDestroy(); }

  save({ password: passwordInput }: ChangePassword) {
    this.loading = true;
    this.auth
      .selectLoggedUser()
      .pipe(
        switchMap(({ id, username }) =>
          this.updateUserGQL.mutate({
              username,
              password: passwordInput,
          })
        ),
        tap(() => {
          this.toastr.success(null, this.translate.instant(marker('change_password_success')));
          this.windowRef.close();
        }),
        finalize(() => (this.loading = false)),
        untilComponentDestroyed(this)
      )
      .subscribe();
  }
}
